import { UPDATE_ME, UPDATE_ME_ERROR } from "../types";
import { BasicAccountProps } from "../../types/actions/basicAccount";

import * as api from "../../api/axiosBase";

export const updateMe =
  (formData: BasicAccountProps, history: any) => async (dispatch) => {
    try {
      const { data } = await api.updateMe(formData);
      dispatch({ type: UPDATE_ME, payload: data });
      dispatch({ type: UPDATE_ME_ERROR, payload: "" });
      history.push("/processors");
    } catch (error) {
      //dispatch({ type: UPDATE_ME, payload: error.response.data });
      dispatch({ type: UPDATE_ME_ERROR, payload: error.response.data });
    }
  };
